// --- MODELS for the Field Team Hierarch

/**
 * Store inside a FieldTeam Sector
 */
export class FTStore {
  id: number;
  name: string;
  codeClient: string;
}

/**
 * Customer Sector inside FieldTeam
 */
export class FTSector {
  sectorId: number;
  sectorName: string;
  stores: FTStore[] = [];
}

/**
 * Customer Area inside a FieldTeam
 */
export class FTArea {
  areaName: string;
  areaId: number;
  sectors: FTSector[] = [];
}

/**
 * Customer Field Team
 */
export class FieldTeam {
  fieldTeamId: number;
  fieldTeamName: string;
  customerBu: number;
  areas: FTArea[] = [];

  static asFieldTeam(src: FieldTeam): FieldTeam {
    let ft = new FieldTeam();
    ft.fieldTeamId = src.fieldTeamId;
    ft.fieldTeamName = src.fieldTeamName;
    ft.customerBu = src.customerBu;
    ft.areas = src.areas;
    return ft;
  }
}

/**
 * FieldTeam Universe : All FieldTeams with Areas, Sectors, and Store (stubs, minimal information)
 */
export class FieldTeamStoreUniverse {

  fieldTeamStoreUniveses: FieldTeam[] = [];

  static fromApi(src: FieldTeamStoreUniverse): FieldTeamStoreUniverse {
    let ftsu = new FieldTeamStoreUniverse();
    if (src.fieldTeamStoreUniveses != null) {
      for (const e of src.fieldTeamStoreUniveses) {
        ftsu.fieldTeamStoreUniveses.push(FieldTeam.asFieldTeam(e))
      }
    }
    return ftsu;
  }

  /**
   *
   */
  findAreas(): FTArea[] {
    const areas: FTArea[] = [];
    if (this.fieldTeamStoreUniveses != null) {
      this.fieldTeamStoreUniveses.forEach(ft => {
        if (ft.areas != null)
          ft.areas.forEach(a => areas.push(a));
      });
    }
    return areas;
  }


  findSectors(currentAreaId: number) {
    if (this.fieldTeamStoreUniveses != null) {
      for (const ft of this.fieldTeamStoreUniveses) {
        if (ft.areas != null)
          for (const e of ft.areas) {
            if (currentAreaId == e.areaId) {
              return e.sectors;
            }
          }
      }
    }
    return [];
  }
}



// WEBPACK FOOTER //
// ./src/model/FieldTeam.ts